import { HttpInterceptorFn } from '@angular/common/http';
import { HeaderKeys, StorageKeys } from '../constants/common.constants';

export const headerInterceptor: HttpInterceptorFn = (req, next) => {
  const headerValue = sessionStorage.getItem(StorageKeys.DEPARTMENTS_SELECTED) || '';
  const clonedRequest = req.clone({
    setHeaders: {
      [HeaderKeys.DEPARTMENTS_SELECTED]: headerValue,
    },
  });
  return next(clonedRequest);
};
